// Base64-encode messages/context to avoid WAF rules tripping on
// URLs/underscores/etc in user content. Text encoder allows for
// emojis in text
export const encodeB64 = (s: string): string => {
    return btoa(String.fromCharCode(...new TextEncoder().encode(s)));
};
